(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name trainingPrograms.service:trainingProgramEditorService
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .service('TrainingProgramEditorService', TrainingProgramEditorService);
    function TrainingProgramEditorService(CommonLogicService, RemoteService, applicationConstants) {
        var self = this, trainingProgramsDetails=[],trainingStations=[];
        self.model = {
            statusList:[],
            stationList:[],
            locationList:[],
            allLocationList:[],
            airCraftTypes:[],
            programsCategories:[],
            programsDetails:[],
            baseStation:null,
            subProgramMap :[],
            displayWeekdays: CommonLogicService.getDayOfWeeks()
        };

        function SaveTrainingProgramRequest() {
            // mandatory fields
            this.stationLocationID=null;
            this.aircraftModelNo=null;
            this.slotName=null;
            this.status=null;
            this.startTime=null;
            this.endTime=null;
            this.duration=null;
            this.trainingProgCategory=null;
            this.fromDate=null;
            this.trainingProgramIds = [];
            this.monday = false;
            this.tuesday = false;
            this.wednesday = false;
            this.thursday = false;
            this.friday = false;
            this.saturday = false;
            this.sunday = false;
            this.forceAdd = false;

            // others
            this.trainingSlotId=null;
            this.version=null;
            this.toDate=null;
            this.conflictsDateTimes=[];
            this.hotelCost=null;
            this.hotelCostType=null;
            this.subProgramId = null;
            this.referenceId = null;
            this.trainingProgramCode = null;
        }

        self.adeptTrainingWithEditor = function (training) {
            return AdeptTrainingForEditor(training);
        };

        self.setStatusList = function (statusList) {
            self.model.statusList = statusList;
        };

        self.setStationList = function(stList){
            self.model.stationList = stList;
        };

        self.setLocationList = function (locList) {
            self.model.locationList = locList;
        };

      self.setAllLocationList = function (alllocList) {
        self.model.allLocationList = alllocList;
      };

        self.setBaseStation = function (baseStationCode) {
            self.model.baseStation = baseStationCode;
        };

        self.setAircraftTypes = function (aircraftTypes) {
            self.model.airCraftTypes = aircraftTypes;
        };

        self.calculateDuration = function (selectedTraining) {
            return CommonLogicService.calculateDuration(null, selectedTraining.startTime, null, selectedTraining.endTime);
        };

        self.setProgramCategories = function (programsCategories) {
            self.model.programsCategories = removeAnyFromList(programsCategories);
        };

        self.getProgramCategories = function () {
            return self.model.programsCategories;
        }

        self.setProgramDetails = function (programDetails) {
            self.model.programsDetails = programDetails;
        };


      self.getTrainingLocationByStation = function (station) {
          trainingStations[station] = _.filter(self.model.allLocationList, {"trainingStation":station});
          return trainingStations[station];
      };

      self.getAllTrainingLocationByStation = function (successFn, errorFn) {
          RemoteService.loadTrainingLocationByStation('').then(
            function (response) {
              successFn( response.locationList);
            },
            function (error) {
              errorFn(error)
            }
          );
      };

        self.getStationByCode = function (stationCode) {
            var airportCode = {"airPortCode":stationCode, "airPortName":stationCode};
            airportCode = _.find(self.model.stationList, {"airPortCode":stationCode}) || airportCode;
            return airportCode;
        };

        self.getSelectedLocationByCode = function (locationCode) {
            return _.find(self.model.locationList, {"trainingLocationCode":locationCode});
        };

        self.getSelectedProgramDetailSByCode = function (programCode) {
            return _.find(self.model.programsDetails, {"trainingProgCode":programCode});
        };

        self.setSelectedToSaveTraining = function (selectedTraining) {
            return selectedToSaveTraining(selectedTraining);
        };

        self.getTrainingProgramDetailsByCategory = function (category, successFn, errorFn) {
            if (!!trainingProgramsDetails[category]) {
                successFn(trainingProgramsDetails[category]);
            } else {
                RemoteService.getTrainingProgramsByCategoryCode(category).then(
                    function (response) {
                        trainingProgramsDetails[category] = response.trainingProgramList;
                        successFn(response.trainingProgramList);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };

        self.searchSubPrograms = function (successFn, errorFn) {
            RemoteService.searchTrainingSubPrograms().then(function(response){
            	var subProgramMap = populateTrainingSubProgramMap(response.trainingProgDetailDTOs);
            	self.model.subProgramMap = subProgramMap;
                successFn(subProgramMap);
            },
            function(error){
                if(error.msg===undefined){
                    error.msg[0] = "Service Error";
                }
                errorFn(error.msg[0]);
            });
        };

        function removeAnyFromList(list) {
            if (list!==undefined && list.length>0){
                var copyList = angular.copy(list);
                for(var i=0;i<copyList.length;i++){
                    if(copyList[i].categoryCode===null){
                        copyList.splice(i, 1);
                        break;
                    }
                }
            }
            return copyList;
        }

        function selectedToSaveTraining(selected) {
            var saveRequest = new SaveTrainingProgramRequest();
            saveRequest.stationLocationID = selected.trainingLocationObject.stationLocationId;
            saveRequest.startTime = selected.startTime;
            saveRequest.endTime = selected.endTime;
            saveRequest.fromDate = selected.startDate;
            saveRequest.toDate = selected.endDate;
            saveRequest.duration = selected.duration;
            saveRequest.trainingProgCategory = $.trim(selected.trainingProgramObject.categoryCode);
            saveRequest.slotName = selected.slotName;
            saveRequest.aircraftModelNo = $.trim(selected.airCraftTypeObject.airCraftType);
            saveRequest.status = selected.statusObject.status;
            if(selected.programDetailsObject.length!==0){
                saveRequest.trainingProgramIds[0] = selected.programDetailsObject.trainingProgramId;
                saveRequest.trainingProgramCode = selected.programDetailsObject.trainingProgCode;
            }
            saveRequest.version = selected.version==null?null:selected.version;
            saveRequest.trainingSlotId = selected.trainingSlotID==null?null:selected.trainingSlotID;
            saveRequest.referenceId = selected.referenceId==null?null:selected.referenceId;
            for (var i=1;i<selected.selectedDays.length;i++){
                var day = selected.selectedDays[i];
                saveRequest[day.value] = day.selected;
            }

            saveRequest.hotelCostType = selected.costType?selected.costType:null;
            saveRequest.hotelCost = selected.hotelCost?selected.hotelCost:null;

            saveRequest.subProgramId = selected.subProgramDetailsObject != null ? selected.subProgramDetailsObject.trainingProgramDetailId : null;
            saveRequest.numberOfStandInPilots = selected.standInPilots;
            return saveRequest;
        }

        function AdeptTrainingForEditor(training){
            var nTraining = training;
            var statuses = self.model.statusList;
            //Set Status
            var newStatus = _.find(self.model.statusList, {"status":training.trainingProgramStatusCode});
            nTraining.statusObject = newStatus;

            //Set Station
            var newStation = _.find(self.model.stationList, {"airPortCode":training.trainingStationCode});
            nTraining.stationObject = newStation;

            //filterLocations
           self.model.locationList = _.filter(self.model.allLocationList, {"trainingStation":training.trainingStationCode});

            //Set Location
            var newLocation = _.find(self.model.locationList, {"stationLocationId":training.trainingLocationCode});
            nTraining.trainingLocationObject = newLocation;

            //Set Aircraft Type
            var newAircraftType = _.find(self.model.airCraftTypes, {"modelNumber":training.flightModelNumber + " "});
            nTraining.airCraftTypeObject = newAircraftType;

            //Set duration
            var duration = CommonLogicService.calculateDuration(nTraining.startDate, nTraining.startTime, nTraining.endDate, nTraining.endTime);
            nTraining.duration = duration;

            //Set training program
            var program = _.find(self.model.programsCategories, {"categoryCode":training.trainingProCategory + " "});
            nTraining.trainingProgramObject = program;

            //Set training program details
            var program = _.find(self.model.programsDetails, {"trainingProgramId":training.subPrograms[0].subProgramId});
            nTraining.programDetailsObject = program;


            if(training.trainingSlotID){
            	var subPrgramList = _.find(self.model.subProgramMap, {"trainingProgramId":training.subPrograms && training.subPrograms[0].subProgramId});
            	var subProgramObject =  null;
            	if(!!subPrgramList){
            		subProgramObject =  _.find(subPrgramList.trainingSubProgramList, {"trainingProgramDetailId":training.selectedTrainingProId});
            	}
            	nTraining.subProgramDetailsObject = subProgramObject;
            }

            //Set Selected Days
            nTraining.selectedDays = self.model.displayWeekdays;

            nTraining.hotelCost = training.hotelCost;
            nTraining.costType = training.hotelCostType;
            nTraining.standInPilots = training.numberOfStandInPilots;

          return nTraining;
        }

        function populateTrainingSubProgramMap(subProgramList) {

        	var subProgramMap = [];

            angular.forEach(subProgramList, function (subProgram) {

            	  var subPrgm = null;

            	  angular.forEach(subProgramMap, function (subProgramMapKey) {
            		  if(subProgramMapKey.trainingProgramId == subProgram.trainingProgramId){
            			  subPrgm = subProgramMapKey;
            			  return;
            		  }
            	  });

            	  if(subPrgm == null){
            		  subPrgm = createTrainingWiseSubProgram(subProgram);
            		  var details = createTrainingSubProgram(subProgram);
                	  subPrgm.trainingSubProgramList.push(details);
                	  subProgramMap.push(subPrgm);
            	  } else {
            		  var details = createTrainingSubProgram(subProgram);
                	  subPrgm.trainingSubProgramList.push(details);
            	  }

            });

            return subProgramMap;
        }



		function TrainingWiseSubProgram() {
			this.trainingProgramId = null;
			this.trainingSubProgramList = [];
		}

		function TrainingSubProgram() {
			this.trainingProgramDetailId = null;
			this.subProgramCode = null;
			this.subProgramDesc = null;
			this.trainingProgramId = null;
		}

		function createTrainingWiseSubProgram(subProgram) {
			var trainingWiseSubProgram = new TrainingWiseSubProgram();
			trainingWiseSubProgram.trainingProgramId = subProgram.trainingProgramId;
			return trainingWiseSubProgram;
		}

		function createTrainingSubProgram(subProgram) {
			var trainingSubProgram = new TrainingSubProgram();
			trainingSubProgram.trainingProgramDetailId = subProgram.trainingProgramDetailId;
			trainingSubProgram.subProgramCode = subProgram.trainingProgDetailCode;
			trainingSubProgram.subProgramDesc = subProgram.trainingProgDetailDesc;
			trainingSubProgram.trainingProgramId = subProgram.trainingProgramId;
			return trainingSubProgram;
		}

    }
}());
